import { useEffect, useState } from "react";
import DateFormStyle from "../style/date.component";
import { InputFormProps } from "./interface/formInterface";
import { formatDate } from "../../pages/club/utils/excelExport";

export interface DateRange {
  startDate: string;
  endDate: string;
}

const DateListForm = (props: InputFormProps) => {
  const { value, setValue, label, width } = props;
  const [dateRanges, setDateRanges] = useState<DateRange[]>([]);

  useEffect(() => {
    setDateRanges(
      value.map((item: any) => ({
        startDate: formatDate(item.startDate),
        endDate: formatDate(item.endDate),
      })),
    );
  }, [value]);

  const handleAddDateRange = () => {
    const newDateRange = [...dateRanges, { startDate: "", endDate: "" }];
    setDateRanges(newDateRange);
    setValue(newDateRange);
  };

  const handleRemoveDateRange = (index: number) => {
    const newDateRange = dateRanges.filter((_, i) => i !== index);
    setDateRanges(newDateRange);
    setValue(newDateRange);
  };

  const handleSetStartDate = (index: number, startDate: string) => {
    const newDateRange = [...dateRanges];
    newDateRange[index].startDate = startDate;
    setDateRanges(newDateRange);
    setValue(newDateRange);
  };

  const handleSetEndDate = (index: number, endDate: string) => {
    const newDateRange = [...dateRanges];
    newDateRange[index].endDate = endDate;
    setDateRanges(newDateRange);
    setValue(newDateRange);
  };

  return (
    <div
      style={{
        width: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "10px",
        borderBottom: "1px solid #fff",
        paddingBottom: "15px",
      }}
    >
      <label style={{ color: "white", fontSize: "12px", marginRight: "15px" }}>
        {label}
      </label>
      {dateRanges.map((item, index) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: width,
            alignItems: "center",
          }}
          key={index}
        >
          <DateFormStyle
            value={item.startDate}
            onChange={(e) => {
              handleSetStartDate(index, e.target.value);
            }}
            type="datetime-local"
          />
          <DateFormStyle
            value={item.endDate}
            onChange={(e) => {
              handleSetEndDate(index, e.target.value);
            }}
            type="datetime-local"
          />
          <div
            style={{
              color: "white",
              fontSize: "13px",
              backgroundColor: "red",
              padding: "5px 10px",
              borderRadius: "5px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              height: "fit-content",
            }}
            onClick={() => handleRemoveDateRange(index)}
          >
            삭제
          </div>
        </div>
      ))}
      <div
        style={{
          color: "white",
          fontSize: "13px",
          backgroundColor: "blue",
          padding: "5px 10px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => handleAddDateRange()}
      >
        기간 추가
      </div>
    </div>
  );
};

export default DateListForm;
